import { Components, Theme } from '@mui/material/styles';
import scssVariables from '@styles/variables.module.scss';

export const MuiButton: Components<Theme>['MuiButton'] = {
  defaultProps: {
    disableElevation: true,
    size: 'small',
  },
  styleOverrides: {
    root: {
      borderRadius: '100px',
      paddingLeft: 'var(--spacing-unit-2)',
      paddingRight: 'var(--spacing-unit-2)',
      variants: [
        {
          props: { size: 'tiny' },
          style: {
            height: 'var(--input-height-tiny)',
            fontSize: 'var(--font-size-label)',
            paddingLeft: 'var(--spacing-unit-1)',
            paddingRight: 'var(--spacing-unit-1)',
            '& .icon': {
              '--icon-size': '16px',
              '--icon-variation-settings':
                "'FILL' 0, 'wght' 300, 'GRAD' 0, 'opsz' 16",
            },
          },
        },
        {
          props: { size: 'small' },
          style: {
            height: 'var(--input-height-small)',
            '& .icon': {
              '--icon-size': '20px',
              '--icon-variation-settings':
                "'FILL' 0, 'wght' 300, 'GRAD' 0, 'opsz' 20",
            },
          },
        },
        {
          props: { size: 'medium' },
          style: {
            height: 'var(--input-height-medium)',
            '& .icon': {
              '--icon-size': '24px',
              '--icon-variation-settings':
                "'FILL' 0, 'wght' 300, 'GRAD' 0, 'opsz' 24",
            },
          },
        },
        {
          props: { size: 'large' },
          style: {
            height: 'var(--input-height-large)',
            '& .icon': {
              '--icon-size': '32px',
              '--icon-variation-settings':
                "'FILL' 0, 'wght' 300, 'GRAD' 0, 'opsz' 32",
            },
          },
        },
        {
          props: { variant: 'text', color: 'secondary' },
          style: {
            color: scssVariables.ColorFog100,
          },
        },
        {
          props: { variant: 'contained', color: 'secondary' },
          style: {
            backgroundColor: scssVariables.ColorFog100,

            '&:hover': {
              backgroundColor: scssVariables.ColorFog80,
            },
            '&[aria-pressed="true"], &[aria-expanded="true"]': {
              backgroundColor: scssVariables.ColorBlue10,
              color: scssVariables.ColorBlue80,
            },
          },
        },
        {
          props: { variant: 'outlined', color: 'secondary' },
          style: {
            borderColor: scssVariables.ColorFog100,
            color: scssVariables.ColorFog100,

            '&:hover': {
              backgroundColor: scssVariables.ColorFog10,
            },
            '&[aria-pressed="true"], &[aria-expanded="true"]': {
              backgroundColor: scssVariables.ColorBlue10,
              color: scssVariables.ColorBlue80,
            },
          },
        },
        {
          props: { rounded: true },
          style: {
            borderRadius: 'var(--border-radius-large)',
            paddingLeft: 'var(--spacing-unit-2)',
            paddingRight: 'var(--spacing-unit-2)',
          },
        },
      ],
    },
  },
};
